module.exports = __webpack_public_path__ + "static/media/meubox.572ccdf6.png";